
import {
    IClaimedMessageJson,
        
} from "../../../../../nodeserver/structs/database.js";
import {handleFetchError, showNotice} from "./../../helpers/functions.js";
import {ServerApi} from "./../../api.js";
import JSX from "./../../helpers/react.js";
import { readNumberAttr} from "../../messages/helpers.js";

import { 
    Action, 
    ActionDate, 
    ActionIndicator, 
    ActionOwnerProfileLink, 
    ActionStatus, 
    HistoryContainerElement, 
    MessageStatusComplaints, 
    Text 
} from "./history-elements.js";
import { userReportReasons } from "./actions/report.js";




function ClaimContainerData({el, i}: { el: IClaimedMessageJson, i: number }) {
    
    const containerData = (
        <HistoryContainerElement 
            firstBlock={[
                <ActionIndicator actionClass={getClassForClaimContainer(el)} imgSrc="/img/white-report.svg"/>,
                <ActionDate date={el.date_complaints}/>
            ]}
            actions={[
                <ActionOwnerProfileLink nickname={el.nickname} userId={el.user_id}/>,
                <ActionStatus el={el.status_complaints}/>,
                
                <Action 
                    isOnlySignType = {false}
                    nickname={el.nickname}
                    ownerNick={el.message.owner.nickname}
                    userId={el.message.owner.id}
                />,
                <ClaimReason el={el}/>,
            ]}
            dataElements={[
                <Text text={el.message.text}/>
            ]}
            iterator={i}
            prefix="r"
            className="report"
            additionalBlocks={[
                <ClaimUserAvatar el={el}/>
            ]}
        />
    );
    return containerData;
}




export function getClassForClaimContainer(el: IClaimedMessageJson) : string{
    
    switch(el.status_complaints){
        case MessageStatusComplaints.Reject:
        case MessageStatusComplaints.Resotred:
            return "circle green-bg";
        case MessageStatusComplaints.Add:
        case MessageStatusComplaints.Approved:
        case MessageStatusComplaints.Argue:
            return "circle red-bg";
        default:
            return "";
    }
    
}


export function ClaimUserAvatar(props: {
    el: IClaimedMessageJson
}){
    return <div className="user-avatar">
        <a href={`/users/id${props.el.user_id}`}>
            <img src={props.el.avatars.small}/>
        </a>
    </div>
}


export function ClaimReason(props:{
    el:IClaimedMessageJson
}){
    const allReasons = userReportReasons();
    return <span className="white-text">по причине: {allReasons[props.el.reason - 1]}&nbsp;</span>
}




function ClaimedMessage({el, i}: { el: IClaimedMessageJson, i: number }) {

    if (!el.is_last)
        return <ClaimContainerData el={el} i={i}/>;
    //времменное отключиение функционала
    if (el.status_complaints !== MessageStatusComplaints.Add)
        return <></>;

    return (
        <div className="wrapper message"
            onClick={e => showMessageClaimsByMessageId(e, el.message_id)}
        >
            <ClaimContainerData el={el} i={i}/>
            <ClaimedMessageButtons el={el} claimId={el.claim_id}/>
        </div>
    )

}



async function approveClaim(claimId: number) {
    try {
        await ServerApi.messages.approveClaim(claimId);
        showNotice("Вы удалили сообщение!");
        await reloadCurrentMessagesBans();
    } catch (error) {
        handleFetchError(error);
    }
}


async function rejectClaim(claimId: number) {
    try {
        await ServerApi.messages.rejectClaim(claimId);
        showNotice("Вы отклонили жалобу!");
        await reloadCurrentMessagesBans();
    } catch (error) {
        handleFetchError(error);
    }
}

async function argueClaim(claimId: number) {
    try {
        await ServerApi.messages.argueClaim(claimId);
        showNotice("Вы оспорили решение!");
        await reloadCurrentMessagesBans();
    } catch (error) {
        handleFetchError(error);
    }
}

async function restoreClaim(claimId: number) {
    try {
        await ServerApi.messages.restoreClaim(claimId);
        showNotice("Вы восстановили сообщение!");
        await reloadCurrentMessagesBans();
    } catch (error) {
        handleFetchError(error);
    }
}

async function showMessageClaimsByMessageId(e: { target: HTMLElement }, messageId: number) {
    if (!$(e.target).hasClass("wrapper"))
        return;

    const messageBans = $("#message-bans");
    const messageIdEl = readNumberAttr(messageBans, "messageId");
    if (messageIdEl === 0 || messageIdEl != messageId) messageBans.data("message-id", messageId)
    else messageBans.data("message-id", 0);
    await reloadCurrentMessagesBans();
}


async function reloadCurrentMessagesBans() {

    const messageBans = $("#message-bans");
    const messageIdEl = messageBans.data("message-id");
    if (messageIdEl !== 0)
        await showMessageClaims(1, messageIdEl)
    else
        await showMessageClaims(messageBans.data("page"));


}

export function ClaimedMessages(props: {
    claims: IClaimedMessageJson[]
}) {
    const claims = props.claims;
    return (
        <>
            {...claims.map((el, i) => <ClaimedMessage el={el} i={i}/>)}
        </>
    );
}

export async function showMessageClaims(page: number, messageId: number = 0) {
    try {
        const messageBans = $("#message-bans");
        const messagesBlock = messageBans.find(".messages-block");


        $("#bans-container").children().removeClass("active");
        ;

        messageBans.addClass("active");

        let claimedMessages = await ServerApi.messages.getClaimed(page, messageId);
        const claimedMEssagesElements = <ClaimedMessages
            claims={claimedMessages}
        >
        </ClaimedMessages>;

        messagesBlock.children().remove();
        messagesBlock.prepend(claimedMEssagesElements);
        messageBans.data("page", page);

        messageBans.data("message-id", messageId)
    } catch (error) {
        handleFetchError(error);
    }
}


function ClaimedMessageButtons({el, claimId}: { el: IClaimedMessageJson, claimId: number }) {
    const buttons = [];
    if (el.status_complaints === MessageStatusComplaints.Approved)
        buttons.push(<>
            <button className="main-button bordered" onClick={() => restoreClaim(claimId)}
                >Восстановить
            </button>
        </>)
        
    if (el.status_complaints === MessageStatusComplaints.Resotred)
        buttons.push(<>
            <button className="main-button bordered"
                    onClick={() => rejectClaim(claimId)}
            >Отклонить
            </button>
            <button className="main-button attention bordered"
                    onClick={() => approveClaim(claimId)}
            >Удалить
            </button>
        </>)
    if (el.status_complaints === MessageStatusComplaints.Reject)
        buttons.push(<>
            <button className="main-button attention bordered"
                    onClick={() => argueClaim(claimId)}
            >Оспорить
            </button>
        </>)
    if (el.status_complaints === MessageStatusComplaints.Argue || el.status_complaints === MessageStatusComplaints.Add)
        buttons.push(<>
            <button className="main-button bordered"
                    onClick={() => rejectClaim(claimId)}
            >Отклонить
            </button>
            <button className="main-button attention bordered"
                    onClick={() => approveClaim(claimId)}
            >Удалить
            </button>
        </>);

    return <div className="button">
        {...buttons}
    </div>

}
